const parseDewey = (s) => s.split(".").map(Number);
export const compareDeweyDecimal = (a, b) => {
    const parseDewey = (s) => s.split(".").map(Number);
    const partsA = parseDewey(a);
    const partsB = parseDewey(b);
    for (let i = 0; i < Math.min(partsA.length, partsB.length); i++) {
        if (partsA[i] < partsB[i])
            return -1;
        if (partsA[i] > partsB[i])
            return 1;
    }
    return partsA.length - partsB.length;
};
export const getDewyDecimalIndexBetween = (a, b) => {
    const parseDewey = (s) => s.split(".").map((part, index) => {
        // Convert the first part to number normally, but handle decimal parts by dividing to adjust for their place value
        return index === 0 ? Number(part) : Number(`0.${part}`);
    });
    const aParts = parseDewey(a);
    const bParts = parseDewey(b);
    const primaryA = aParts[0];
    const primaryB = bParts[0];
    const decimalA = aParts.length > 1 ? aParts[1] : 0;
    const decimalB = bParts.length > 1 ? bParts[1] : 0;
    if (primaryA === primaryB) {
        if (decimalA === decimalB) {
            // Handling identical decimals by arbitrarily making a new decimal that is slightly higher
            const output = `${primaryA}.${decimalA * 100 + 5}`; // Convert back to integer-like handling and add 5
            return output;
        }
        // Calculate the midpoint properly by ensuring decimals are not treated as whole numbers
        const midpointDecimal = (decimalA + decimalB) / 2;
        const output = `${primaryA}.${String(midpointDecimal).split(".")[1] || "0"}`;
        return output;
    }
    else {
        // Combine primary and decimal for precise calculation across primary categories
        const valueA = primaryA + decimalA;
        const valueB = primaryB + decimalB;
        const midpoint = (valueA + valueB) / 2;
        const midPrimary = Math.floor(midpoint); // Integer part of the midpoint
        const midDecimal = midpoint - midPrimary; // Fractional part of the midpoint
        const output = `${midPrimary}${midDecimal > 0 ? `.${String(midDecimal).split(".")[1] || "0"}` : ""}`;
        return output;
    }
};
export const getDewyDecimalIndexBefore = (a) => {
    const parts = parseDewey(a);
    const primary = parts[0];
    const decimal = parts.length > 1 ? parts[1] : 0;
    let output;
    if (decimal > 0) {
        const newDecimal = decimal - 1;
        output = `${primary}.${newDecimal}`;
    }
    else {
        output = `${primary - 1}.9`;
    }
    return output;
};
export const getDewyDecimalIndexAfter = (a) => {
    const parts = parseDewey(a);
    const primary = parts[0];
    const decimal = parts.length > 1 ? parts[1] : 0;
    let output;
    if (decimal < 9) {
        const newDecimal = decimal + 1;
        output = `${primary}.${newDecimal}`;
    }
    else {
        output = `${primary + 1}.0`;
    }
    return output;
};
